import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class MachineTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('MachineTypeReference');
  }
}
